var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from "react";
var initialState = {
    handleClose: function () {
        throw new Error("handleClose() is not implemented");
    },
    goToRewardsPage: function () {
        throw new Error("goToRewardsPage() is not implemented");
    },
};
var RewardsModalConfigContext = createContext(initialState);
RewardsModalConfigContext.displayName = "RewardsModalConfigContext";
export var useRewardsModalConfigContext = function () {
    return useContext(RewardsModalConfigContext);
};
var RewardsModalConfigContextProvider = function (_a) {
    var state = _a.state, children = _a.children;
    var travelNotificationState = useMemo(function () { return state; }, [state]);
    return (_jsx(RewardsModalConfigContext.Provider, __assign({ value: travelNotificationState }, { children: children })));
};
export default RewardsModalConfigContextProvider;
